import { LitElement, html, svg } from 'lit';

export class IconAttachment24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Binders</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m14.86 5.642-8.816 8.819a2.2 2.2 0 0 0 3.112 3.11l8.814-8.82A4.4 4.4 0 1 0 11.75 2.53l-8.816 8.815a6.6 6.6 0 1 0 9.334 9.333L23 10"></path></svg>`; }
}
if (!customElements.get('f-icon-attachment24', IconAttachment24)) {
  customElements.define('f-icon-attachment24', IconAttachment24);
}